/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_Dr as Dr,
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
} from "../../runtime/index.jsx";
export function CapturarFoto(e) {
  let t = (0, ReactCompiler.c)(7),
    { onFile: n, disabled: r } = e,
    i;
  t[0] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((i = [`Tomar foto`, `Elegir foto`]), (t[0] = i))
    : (i = t[0]);
  let a;
  t[1] !== r || t[2] !== n
    ? ((a = (
        <div
          className={`grid grid-cols-2 gap-2`}
          children={i.map((e, t) => (
            <label
              key={e}
              className={`flex min-h-12 cursor-pointer items-center justify-center gap-2 rounded-xl border border-(--border) p-3 text-sm text-(--text-h) focus-within:ring-2 focus-within:ring-(--accent)`}
              children={[
                <Dr className={`h-5 w-5 shrink-0`} />,
                e,
                <input
                  aria-label={e}
                  className={`sr-only`}
                  type={`file`}
                  accept={`image/jpeg,image/png,image/webp`}
                  capture={t === 0 ? `environment` : void 0}
                  disabled={r}
                  onChange={(e) => {
                    let t = e.target.files?.[0];
                    ((e.target.value = ``), t && n(t));
                  }}
                />,
              ]}
            />
          ))}
        />
      )),
      (t[1] = r),
      (t[2] = n),
      (t[3] = a))
    : (a = t[3]);
  let o;
  t[4] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((o = (
        <p
          className={`text-xs text-(--text)`}
          children={`Fotos JPG, PNG o WebP. Se ajustan antes de enviarlas.`}
        />
      )),
      (t[4] = o))
    : (o = t[4]);
  let s;
  return (
    t[5] === a
      ? (s = t[6])
      : ((s = <div className={`space-y-2`} children={[a, o]} />),
        (t[5] = a),
        (t[6] = s)),
    s
  );
}
